import { css, mediaQuery } from 'academy-common-lib/utils/Styling';
export const publicNavButtonStyle = css(["height:100%;display:flex;align-items:center;padding:0 16px;background:none;border:none;color:", ";position:relative;z-index:100;font-size:16px;font-weight:500;", ""], ({
  theme: trellisTheme
}) => trellisTheme.color['do-not-use-obsidian'], mediaQuery('mobile', css(["padding:16px;width:100%;background-color:", ";border:1px solid ", ";border-radius:4px;"], ({
  theme: trellisTheme
}) => trellisTheme.color['do-not-use-gypsum'], ({
  theme: trellisTheme
}) => trellisTheme.color['do-not-use-great-white'])));
export const publicNavButtonHoverStyle = css(["", ""], mediaQuery('notMobile', css(["&::after{content:'';display:block;position:absolute;height:6px;left:0;bottom:-3px;width:100%;border-radius:4px;background-color:", ";}"], ({
  theme: trellisTheme
}) => trellisTheme.color['do-not-use-obsidian'])));